import { useTranslation } from "react-i18next";

import { Text } from "components";

import DashboardTodoContent from "../shared/DashboardTodoContent";

import shellClasses from "./SectionShell.module.css";

interface TodoSectionProps {
  className?: string;
}

const joinClasses = (...values: Array<string | false | null | undefined>) =>
  values.filter(Boolean).join(" ");

const TodoSection = ({ className }: TodoSectionProps) => {
  const { t } = useTranslation();

  return (
    <section className={joinClasses(shellClasses.root, className)}>
      <div className={shellClasses.header}>
        <Text className={shellClasses.title}>{t("dashboard.todo.title")}</Text>
      </div>

      <div className={shellClasses.body}>
        <DashboardTodoContent contentInsetX="0px" />
      </div>
    </section>
  );
};

export default TodoSection;
